import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SessionExpired from "../modules/session-expired";
import ProfileView from "../modules/profile-view-page";
import AgreementPage from "../modules/agreement-page";
import HOAProfile from "../modules/profile-format";
import ClientAgreementPage from "../modules/client-agreement";

const MainRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/profile-view/:id" element={<ProfileView />} />{" "}
        <Route path="/profile" element={<HOAProfile />} />{" "}
        <Route path="/agreement/:id" element={<ClientAgreementPage />} />
        <Route path="/emp-agreement/:id" element={<AgreementPage />} />
        <Route path="/session-expired" element={<SessionExpired />} />
      </Routes>
    </Router>
  );
};

export default MainRoutes;
